import { Controller } from "@hotwired/stimulus"

// Bidirectionally syncs horizontal scroll between the phase header row
// and the kanban column body row so headers follow when the user scrolls.
export default class extends Controller {
  static targets = ["header", "body"]

  connect() {
    this._syncing = false

    this._onHeaderScroll = this._makeScrollHandler(this.headerTarget, this.bodyTarget)
    this._onBodyScroll   = this._makeScrollHandler(this.bodyTarget, this.headerTarget)

    this.headerTarget.addEventListener("scroll", this._onHeaderScroll, { passive: true })
    this.bodyTarget.addEventListener("scroll", this._onBodyScroll, { passive: true })
  }

  disconnect() {
    this.headerTarget.removeEventListener("scroll", this._onHeaderScroll)
    this.bodyTarget.removeEventListener("scroll", this._onBodyScroll)
  }

  // Returns a scroll handler that syncs `source.scrollLeft` → `target.scrollLeft`
  // using rAF to avoid layout thrash and a guard flag to prevent feedback loops.
  _makeScrollHandler(source, target) {
    return () => {
      if (this._syncing) return
      this._syncing = true

      requestAnimationFrame(() => {
        target.scrollLeft = source.scrollLeft
        this._syncing = false
      })
    }
  }
}
